/**
 * 地图找客线索的价值分层标签(1005 上线前收尾)。
 *
 * api 侧真源 = MapLeadScoreService.levelOf(V1.0 五档,按规则总分):
 *   ≥90 极高价值 / ≥80 高价值 / ≥70 值得跟进 / ≥60 一般 / 其余 低优先级。
 * 现网下发的就是这五个中文串;但抽屉原来 `{item.level}` 直出 —— 将来 api 换成码值
 * (HIGH / LOW…)或下发空串,用户就会看到英文/空药丸。这里统一收口:
 *   ① 已知码值(大小写不敏感)→ 中文;② 已是中文 → 原样;
 *   ③ 空 / 未知码值 → 按分数套同一套五档(与 api 同阈值);④ 连分数都没有 → 「未分级」。
 */
const CODE_TO_LABEL: Record<string, string> = {
  EXTREME: "极高价值",
  VERY_HIGH: "极高价值",
  TOP: "极高价值",
  S: "极高价值",
  HIGH: "高价值",
  A: "高价值",
  MEDIUM: "值得跟进",
  MID: "值得跟进",
  FOLLOW: "值得跟进",
  WORTH_FOLLOWING: "值得跟进",
  B: "值得跟进",
  NORMAL: "一般",
  GENERAL: "一般",
  AVERAGE: "一般",
  C: "一般",
  LOW: "低优先级",
  D: "低优先级",
};

export const LEAD_LEVEL_UNKNOWN = "未分级";

/** 与 api MapLeadScoreService.levelOf 同阈值。 */
export function leadLevelFromScore(score: number): string {
  if (score >= 90) return "极高价值";
  if (score >= 80) return "高价值";
  if (score >= 70) return "值得跟进";
  if (score >= 60) return "一般";
  return "低优先级";
}

export function leadLevelLabel(level: string | null | undefined, score?: number | null): string {
  const raw = (level ?? "").trim();
  if (raw) {
    const mapped = CODE_TO_LABEL[raw.toUpperCase().replace(/[\s-]+/g, "_")];
    if (mapped) return mapped;
    if (/[一-鿿]/.test(raw)) return raw;
  }
  if (typeof score === "number" && Number.isFinite(score)) return leadLevelFromScore(score);
  return LEAD_LEVEL_UNKNOWN;
}
